module.exports = __webpack_public_path__ + "ca36d99816ce0951f47feebe9359fef0.pdf";